import ajax from '@/resources/myApi';
import vm from '@/main';
import { listDto, dataItemDto } from './dto';

export const SORT_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC'
};

const SEARCHABLE_FIELDS = [
  /*
  [Columns]
  */
];

const service = {
  getAll,
  getByParams,
  getById,
  create,
  update,
  deleteIds,
};

async function getAll() {
  try {
    const { data } = await ajax.get('api/aes_envelopestat/All', {
      name: 'aes_envelopestat'
    });
    return new listDto(data);
  } catch { }
}

async function getByParams(
  pageNumber,
  pageSize,
  sortBy,
  sortOrder,
  searchQuery,
  searchableFields = SEARCHABLE_FIELDS
) {
  const params = {
    pageNumber,
    pageSize,
    sortBy: transformSortRule(sortBy),
    sortOrder
  };
  if (searchQuery) {
    params.search = JSON.stringify(
      // TODO: This kind of logic should be done on the API end
      searchableFields.map(key => ({
        field: {
          id: key,
          type: 'string'
        },
        condition: 'or',
        value: searchQuery,
        operator: 'like'
      }))
    );
  }

  try {
    const { data } = await ajax.get('api/aes_envelopestat/', {
      name: 'aes_envelopestat',
      params
    });

    return new listDto(data);
  } catch { }
}

async function getById(id) {
  try {
    const { data } = await ajax.get(`api/aes_envelopestat/${id}`, {
      name: 'aes_envelopestat edit'
    });
    return new dataItemDto(data);
  } catch (error) {
    if (error.response.status < 500) {
      // aes_envelopestat does not exist
      vm.$snotify.error('aes_envelopestat not found');
      vm.$router.push({ name: 'aes_envelopestat' });
    }

    return {};
  }
}

async function create(dto) {
  try {
    const { data } = await ajax.post('api/aes_envelopestat', {
      name: 'aes_envelopestat',
      body: dto
    });

    vm.$snotify.success('aes_envelopestat has been created', 'aes_envelopestat');

    return data.id;
  } catch (error) {
    throw error;
  }
}

async function update(dto) {
  try {
    await ajax.put(`api/aes_envelopestat/${dto.id}`, {
      name: 'aes_envelopestat',
      body: dto
    });
    vm.$snotify.success('aes_envelopestat changes saved', 'aes_envelopestat');
  } catch { }
}

async function deleteIds(ids) {
  let param = '?';
  param += ids.map(q => `aes_envelopestatIds=${q}`).join('&');
  try {
    await ajax.delete(`api/aes_envelopestat/DeleteMulti/${param}`, {
      name: 'aes_envelopestat'
    });
  } catch { }
}

function transformSortRule(sortBy) {
  if (sortBy == 'recievedByUserFullName') {
    sortBy = 'RecievedByUser.FullName';
  } else if (sortBy == 'inspectedByUserFullName') {
    sortBy = 'InspectedByUser.FullName';
  }
  return sortBy;
}

export default service;
